import { useState } from 'react';

export default function TestimonialSection() {
  const testimonials = [
    {
      quote: "이런 영화를 기다려왔습니다. 한국 영화의 새로운 가능성을 보여줄 신공에 기대가 큽니다.",
      author: "김○○ 후원자",
      image: "https://public.readdy.ai/ai/img_res/6b33ed0eb09f02017912e03b62ba8689.jpg"
    },
    {
      quote: "윤준호 배우의 연기를 기대하며 후원합니다. 신공이 한국 영화계에 새로운 바람을 일으킬 것이라 믿습니다.",
      author: "이○○ 후원자",
      image: "https://readdy.ai/api/search-image?query=confident%20korean%20professional%20portrait%20with%20friendly%20expression%20wearing%20modern%20casual%20clothing%20against%20clean%20background%20natural%20studio%20lighting&width=600&height=800&seq=testimonial002&orientation=portrait"
    },
    {
      quote: "독립영화의 가능성을 믿고 후원합니다. 신공이 많은 관객들에게 감동을 전할 수 있기를 응원합니다.",
      author: "박○○ 후원자",
      image: "https://readdy.ai/api/search-image?query=young%20korean%20supporter%20portrait%20with%20enthusiastic%20smile%20in%20trendy%20casual%20wear%20against%20soft%20background%20bright%20natural%20lighting%20headshot&width=600&height=800&seq=testimonial003&orientation=portrait"
    }
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  return (
    <section className="py-32 px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-5 gap-16 items-center">
          <div className="col-span-2">
            <div className="rounded-3xl overflow-hidden shadow-xl">
              <img
                src={testimonials[currentIndex].image}
                alt="후원자"
                className="w-full h-[600px] object-cover object-top"
              />
            </div>
          </div>
          
          <div className="col-span-3 space-y-8">
            <p className="text-sm text-gray-500 font-medium tracking-wider uppercase">
              (EARLY SUPPORTER)
            </p>
            
            <h2 
              className="text-5xl font-black leading-tight"
              style={{ fontFamily: "'Noto Serif KR', serif" }}
            >
              후원자들의<br />
              <span className="text-gray-400">진심 어린 응원</span>
            </h2>
            
            <blockquote className="text-2xl text-gray-700 leading-relaxed font-light">
              "{testimonials[currentIndex].quote}"
            </blockquote>
            
            <p className="text-lg font-bold text-gray-900">
              — {testimonials[currentIndex].author}
            </p>
            
            <div className="flex gap-4 pt-8">
              <button
                onClick={handlePrev}
                className="w-12 h-12 flex items-center justify-center border-2 border-gray-300 rounded-full text-gray-600 hover:border-gray-900 hover:text-gray-900 transition-colors cursor-pointer"
              >
                <i className="ri-arrow-left-line text-xl"></i>
              </button>
              <button
                onClick={handleNext}
                className="w-12 h-12 flex items-center justify-center bg-gray-900 rounded-full text-white hover:bg-gray-800 transition-colors cursor-pointer"
              >
                <i className="ri-arrow-right-line text-xl"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
